<template>
  <div>
    <SecuritySettingInner v-if="defaultPage"></SecuritySettingInner>
    <SecuritySettingInnerBv v-if="is8V"></SecuritySettingInnerBv>
    <!-- <IndexInner v-if="is8V && darkMode == 1"></IndexInner> -->
  </div>
</template>
<script>
import { VUE_UNION_STATION } from "@/assets/js/stationSetting";
import { translateTitle } from "@/assets/js/i18n";
import SecuritySettingInner from "@/pages/ucenter/kyc-setting-inner.vue";
import SecuritySettingInnerBv from "@/pages/ucenter/security-setting-inner-bv.vue";
export default {
  mixins: [],
  data() {
    return {
      is8V: false,
      defaultPage: false,
    };
  },
  components: { SecuritySettingInner, SecuritySettingInnerBv },
  computed: {},
  created() {
    if (VUE_UNION_STATION == "8V") {
      this.is8V = true;
    } else {
      this.defaultPage = true;
    }
  },
  beforeDestroy() {},
  destroyed() {},
  mounted() {},
  methods: {
    translateTitle,
  },
};
</script>
<style lang="scss"></style>
